module["exports"] = ["#{city_name}#{city_suffix}"];